import { ReactElement } from 'react'
import { Stack } from 'syf-component-library/ui/spacing'
import { Description, TextWrapper } from './subcomponents'
import { ContentWrapper, ImageWrapper } from '../subcomponents'

interface AddAccountResponseProps {
  image: string
  title: string
  description: string
}

const AddAccountResponseScreen = ({
  image,
  title,
  description
}: AddAccountResponseProps): ReactElement => {
  return (
    <ContentWrapper data-test={title}>
      <ImageWrapper>
        <img
          src={image}
          alt={`${title} Banner`}
          data-cy="add-account-response-image"
        />
      </ImageWrapper>
      <Stack size="large" />
      <TextWrapper
        data-cy="add-account-response-title"
        data-test="add-account-response-title"
      >
        {title}
      </TextWrapper>
      <Stack size="large" />
      <Description data-cy="add-account-response-description">
        {description}
      </Description>
    </ContentWrapper>
  )
}

export default AddAccountResponseScreen
